import React, { useState, useEffect, useCallback } from "react";
import { Layout, Input, Skeleton } from "antd";
import "./index.scss";
import axiosInstance from "@/axios/axiosInstance";
import _ from "lodash"; // 引入lodash来使用_.debounce

const { Header, Footer } = Layout;

const DataGallery = () => {
  // 标签数据，这里只是示例
  // 控制展开/收起状态，使用面板的key作为activeKey
  const [dataSet, setData] = useState([]);
  const [selected, setSelected] = useState(1); // 默认选中第一个子元素

  const getData = useCallback(
    async (a) => {
      let param = `label=${selected || ""}&title=${a || ""}&page=1&limit=400`;
      try {
        const response = await axiosInstance.get(`/paper/page/list?${param}`);
        let compute = response.data.data;
        setData(compute);
      } catch (error) {
        console.error("Error fetching user info:", error);
      }
    },
    [selected] // 确保 getData 只在 selected 变化时重新创建
  );

  useEffect(() => {
    getData();
    document.title =
      "渐风ai,AI论文,人工智能论文,AI研究论文,AI论文分享,AI专业论文";
  }, [selected, getData]); // 将 getData 添加到依赖项数组// 空依赖项数组表示这个 effect 只在组件挂载时运行
  // 处理价格区间的变化

  // 搜索函数（这里只是打印了价格区间，实际中可能是发送请求）

  const debouncedFetchData = _.debounce(getData, 1000);
  const handleChange = (e) => {
    debouncedFetchData(e.target.value);
  };
  const toDetail = (record) => {
    // 构建 URL 参数
    const params = new URLSearchParams({
      id: record.paperId,
      profilePictureUrl: record.profilePictureUrl,
      nickName: record.nickName,
    });
    const url = `/paper_detail?${params.toString()}`;
    window.open(url, "_blank"); // 在新窗口或新标签页中打开
  };
  const babelList = [
    { key: 1, value: "神经网络" },
    { key: 2, value: "自然语言理解 " },
    { key: 3, value: "强化学习" },
    { key: 4, value: "大模型" },
    { key: 5, value: "具身智能" },
  ];
  const getLabel = (v) => {
    return babelList.find((j) => j.key == v.label).value || "";
  };
  return (
    <div>
      <Layout className="paper">
        <Header className="paper-hea">
          <Input
            placeholder="搜索"
            style={{ width: "300px", marginTop: "16px" }}
            onChange={handleChange}
            allowClear
          />
        </Header>
        <div className="chuzsz">论文专题</div>
        <div className="soujg">
          {babelList.map((item) => (
            <div
              key={item.key}
              className={`souj${item.key} ${
                selected === item.key ? "selected" : ""
              }`}
              onClick={() => setSelected(item.key)}
            >
              <p>{item.value}</p>
              <img src={require(`./img/${item.key}.png`)} alt="" />
            </div>
          ))}
        </div>
        <Footer className="paperfoot">
          {dataSet.length ? (
            dataSet.map((v, index) => {
              return (
                <div
                  className="cont-san"
                  key={v.paperId}
                  onClick={() => toDetail(v)}
                >
                  <div className="cont-l">
                    <div className="tilPer">
                      <div className="title">{v.title} </div>
                      <span className="xiaq"> 详情 </span>
                    </div>
                    <div className="label">{getLabel(v)}</div>
                  </div>
                  <div className="cont-r">
                    {/* <div className="concent">11</div> */}
                    <div className="originalAuthor">
                      原作者：{v.originalAuthor}
                    </div>
                    <div className="child send">
                      <span>
                        <img src={v.profilePictureUrl} className="tx" alt="" />
                        <span>{v.nickName} </span>
                        <span className="nickName">{v.updateTime}</span>
                      </span>
                    </div>
                  </div>
                </div>
              );
            })
          ) : (
            <Skeleton active paragraph={{ rows: 4 }} />
          )}
        </Footer>
      </Layout>
    </div>
  );
};

export default DataGallery;
